import {
  OrderServiceItem,
} from '@dapi/sdk';
import {
  arnEwrFlightItem,
} from './flights';
import {
  servicesPricing,
} from './price';
import {
  traveler,
} from './traveler';

export const serviceItem: OrderServiceItem[] = [
  {
    id: 'TSM24',
    descriptions: [
      {
        type: 'shortText',
        content: 'MBAG'
      },
      {
        type: 'longText',
        content: 'ADDITIONAL BAGGAGE'
      }
    ],
    reasonForIssuance: {
      code: 'C',
      subCode: '0C3'
    },
    quantity: 1,
    flightIds: [arnEwrFlightItem.id],
    statusCode: 'HK',
    parameters: [
      {
        code: 'TEXT',
        value: 'ADDITIONAL BAG UP TO 50LB 23KG 62LI 158CM'
      }
    ],
    travelerId: traveler.id,
    isChargeable: true,
    prices: servicesPricing,
    details: [
      {
        flightId: arnEwrFlightItem.id,
        quantity: 1
      }
    ]
  }
];
